const NB = '\u00A0';
/** Пробіли між цифрами — нерозривні, щоб великі числа не розривалися (ТЗ 21, «Контент»). */
export const nb = (s: string) => s.replace(/(\d) (?=\d)/g, `$1${NB}`).replace(/ ([+=−×<>…–]) /g, `${NB}$1 `);
export const fmt = (n: number) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, NB);
export function plural(n: number, forms: [string, string, string]) {
  const a = Math.abs(n) % 100, b = a % 10;
  if (a > 10 && a < 20) return forms[2];
  if (b > 1 && b < 5) return forms[1];
  if (b === 1) return forms[0];
  return forms[2];
}
export const days = (n: number) => `${n} ${plural(n, ['день', 'дні', 'днів'])}`;
export const dateUA = (iso: string) => new Date(iso).toLocaleDateString('uk-UA', { day: 'numeric', month: 'long' });
export const digitsOf = (n: number) => String(n).split('');
